import { render, staticRenderFns } from "./CourseShowPrice.vue?vue&type=template&id=a0fff0c0&scoped=true&"
import script from "./CourseShowPrice.vue?vue&type=script&lang=js&"
export * from "./CourseShowPrice.vue?vue&type=script&lang=js&"
import style0 from "./CourseShowPrice.vue?vue&type=style&index=0&id=a0fff0c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fff0c0",
  null
  
)

export default component.exports